
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">

  @if (!isConsumerCampaign) {
    <div fxLayout="column" fxLayoutGap="20px" class="mat-typography">
      <div fxLayout="row" fxLayoutAlign="start" fxFlexFill fxLayoutGap="20px">
        <mat-slide-toggle fxFlex [formControl]="form.controls.validateReward" color="primary">
          <label class="form-label">Validate reward</label>
        </mat-slide-toggle>
      </div>
    </div>
  }


  @if (isConsumerCampaign) {
    <div fxLayout="column" fxLayoutGap="20px" class="mat-typography">
      <app-reward-data-edit fxFlex="50%"
        [formControl]="form.controls.joinReward"
        [advertiser]="advertiser" [rewardProductsOptions]="rewardProducts"
        [label]="'Instant win for joining'"
        [allowCoins]="false"
        [allowStamps]="false">
      </app-reward-data-edit>
    </div>
  }

  <!-- <div><pre>{{ form.value | json }}</pre></div> -->

</form>